<!-- Modal Wrapper -->
<div
  *ngIf="isOpen"
  class="fixed inset-0 flex justify-center items-start overflow-y-auto bg-black/40 backdrop-blur-sm z-20 transition-opacity duration-300"
  [class.opacity-0]="!isOpen"
  [class.opacity-100]="isOpen"
  (click)="onClose()"
>
  <div class="mt-6 mb-6 w-full px-[16px] flex justify-center">
    <!-- Modal -->
    <div
      class="bg-white rounded-xl shadow-lg p-[24px] pb-[12px] w-full md:min-w-[700px] max-w-[1280px] h-[calc(100vh-1rem)] flex flex-col transform transition-all duration-300 ease-in-out
      {{ modalClass }}"
      [class.opacity-0]="!isOpen"
      [class.scale-0]="!isOpen"
      [class.opacity-100]="isOpen"
      [class.scale-100]="isOpen"
      (click)="$event.stopPropagation()"
    >
      <h2 class="text-xl font-semibold mb-4" *ngIf="title">{{ title }}</h2>
      <div class="h-full overflow-y-auto">
        <ng-template #modalContainer></ng-template>
      </div>
      <div class="pt-[8px] flex justify-end">
        <button
          class="border border-primary text-red-500 px-[24px] py-[4px] rounded"
          (click)="onClose()"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</div>
